module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active is-clipped",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-card",
    attrs: {
      "tabindex": "0",
      "id": _vm.id
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-card-body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "middle-modal"
  }, [_vm._m(1), _c('div', {
    staticClass: "qr-container has-text-centered"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "is-loading"
  }, [_c('i', {
    staticClass: "fa fa-qrcode fa-fade"
  })]), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    attrs: {
      "id": "qrcanva"
    }
  })])]), _c('div', {
    staticClass: "down-modal"
  }, [_vm._m(2), _c('p', {
    staticClass: "mb-20 address-container has-text-centered"
  }, [_c('b', {
    staticClass: "wb-ba text-white-on-dark fw-400 fs-15 address-field"
  }, [_vm._v(_vm._s(_vm.address))]), (_vm.memo) ? _c('b', {
    staticClass: "wb-ba text-white-on-dark fw-600 fs-15 address-field"
  }, [_vm._v(":" + _vm._s(_vm.memo))]) : _vm._e()])])])]), _c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns upper-modal"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v("First be sure to install our Monitoring App")]), _c('i', {
    staticClass: "fa fa-mobile"
  })]), _c('div', {
    staticClass: "column has-text-left"
  }, [_c('a', {
    staticClass: "get-app-image android",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.unmineable.mobileapp",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/app-store-badge-android.png"
    }
  })]), _c('a', {
    staticClass: "get-app-image",
    attrs: {
      "href": "https://apps.apple.com/pe/app/unmineable/id6444838563",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/app-store-badge.svg"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description has-text-centered"
  }, [_c('span', [_vm._v("Scan this QR in the Address option:          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "big-info main mb-10 fs-16 has-text-centered"
  }, [_c('span', {
    staticClass: "text-white-on-dark"
  }, [_vm._v("...or ")]), _c('span', {
    staticClass: "fw-400"
  }, [_vm._v("Copy & Paste ")]), _c('span', [_vm._v("your address manually")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e83f2f76","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_generate_qr.vue
// module id = 393
// module chunks = 1